// Admin panel allowlist — signed-in accounts only (Google / Apple / Facebook).
// Prefer Firebase UID for Apple/Facebook: they often hide or omit email.

export const ADMIN_EMAIL_ALLOWLIST = [
    "justmrmatt@gmail.com",
];

/**
 * Firebase Auth UIDs for admin access.
 * Find yours: Firebase Console → Authentication → Users → copy User UID
 * after signing in with Apple or Facebook once.
 */
export const ADMIN_UID_ALLOWLIST = [
    "E2eGOSMiR3f00SKBJqGWWmoqqrb2", // Apple
    "w7i1cLwlxhe8koDUjMILhN9BJcP2", // Facebook
];

function normalizeEmail(email) {
    return String(email || "")
        .trim()
        .toLowerCase();
}

function normalizeUid(uid) {
    return String(uid || "").trim();
}

export function isAdminEmail(email) {
    const normalized = normalizeEmail(email);
    if (!normalized) {
        return false;
    }
    return ADMIN_EMAIL_ALLOWLIST.map(normalizeEmail).includes(normalized);
}

export function isAdminUid(uid) {
    const normalized = normalizeUid(uid);
    if (!normalized) {
        return false;
    }
    return ADMIN_UID_ALLOWLIST.map(normalizeUid)
        .filter(Boolean)
        .includes(normalized);
}

function collectUserEmails(user) {
    if (!user) {
        return [];
    }

    const emails = [];
    const primary = normalizeEmail(user.email);
    if (primary) {
        emails.push(primary);
    }

    (user.providerData || []).forEach((entry) => {
        const providerEmail = normalizeEmail(entry?.email);
        if (providerEmail) {
            emails.push(providerEmail);
        }
    });

    return [...new Set(emails)];
}

/**
 * Admin Panel is visible only when the feature flag is on AND the signed-in
 * user matches an allowlisted email or Firebase UID. Guests never see it.
 */
export function canAccessAdminPanel(user, { enabled = true } = {}) {
    if (!enabled || !user) {
        return false;
    }

    if (isAdminUid(user.uid)) {
        return true;
    }

    return collectUserEmails(user).some((email) => isAdminEmail(email));
}
